import {deepClone, mask} from "@/utils/index";
import Vue from "vue";
import {timeStampToDate, numberFormat} from "@/utils/index";

export const REFRESH_PAGE_KEY = {
  nursingTaskIndex: 'nursingTaskIndex',
}

/**
 * 页面刷新
 * 一般流程A <-> B B页面进来先调 deleteRefreshStatus 有请求时调setRefreshStatus  A页面onShow调getRefreshStatus判断是否要刷新 A:onUnLoad需调deleteRefreshStatus
 */
export const refresh = {
  namespaced: true,
  state: {
    refresh: {},// key 相关页面
  },
  getters: {
    getRefreshStatus: state => pageKey => {
      return state.refresh[pageKey] || false;
    },
  },
  mutations: {
    setRefreshStatus(state, {pageKey, status}) {
      Vue.set(state.refresh, pageKey, status);
    },
    deleteRefreshStatus(state, pageKey) {
      delete refresh[pageKey]
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/middleware/refresh.js